const apiUrl = "https://api.aiteditor.org"
// const apiUrl = "http://localhost:8080"
const restUrl = "https://pgrst.aiteditor.org"
const maxPath = "activity_test_problem_id_max"
const createQuestionPath = "activity_test_problem"
const createSelectionPath = "activity_test_problem_selection"
const createAnswerPath = "activity_test_problem_answer"
const activity_test_problem_response = "activity_test_problem_response"
export {apiUrl,restUrl,maxPath,createQuestionPath,createSelectionPath,createAnswerPath,activity_test_problem_response}